export const COUNTRY_CODES = [
    '+91', // India
    '+1',  // USA/Canada
    '+44', // UK
    '+61', // Australia
    '+971', // UAE
    '+65', // Singapore
    '+60', // Malaysia
    '+977', // Nepal
    '+880', // Bangladesh
    '+94'  // Sri Lanka
];
